export default {
    content: {
        class: [
            // Spacing
            'p-0',

            // Shape
            'border-0',

            // Color
            'text-surface-700',
            'bg-surface-0'
        ]
    },
    grid: {
        class: [
            // flex
            'flex flex-wrap',

            // Spacing
            'ml-0 mr-0 mt-0',

            // Color
            'bg-surface-0'
        ]
    },
    header: {
        class: [
            'font-bold',

            // Spacing
            'p-4',

            // Color
            'text-surface-800',
            'bg-surface-50',
            'border-surface-200 border-y'
        ]
    }
};
